export default "__VITE_ASSET__KJtfse6I__"